module.exports = __webpack_public_path__ + "static/media/FutureProductBlue.da2abb4f.svg";